import { render, staticRenderFns } from "./CreateNote.vue?vue&type=template&id=4b2d73bf&scoped=true&"
import script from "./CreateNote.vue?vue&type=script&lang=js&"
export * from "./CreateNote.vue?vue&type=script&lang=js&"
import style0 from "./CreateNote.vue?vue&type=style&index=0&id=4b2d73bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d73bf",
  null
  
)

export default component.exports